import classNames from 'classnames';
import { Table, TableCell, TableDropdown } from 'components/2-molecules/Table';
import { useEffect, useMemo, useState } from 'react';
import { SelectedFilter } from '../../components/2-molecules/Table';
import styles from './CountyTaxTable.module.scss';
import countyTaxData from './countyTaxData.json';

type County = {
	name: string;
	id: string;
	region: string;
};
export interface CountyTaxTableProps {
	filters?: {
		label: string;
		options: string[];
	}[];
	onTagSelected: (v: string) => void;
	onTagRemoved: (v: string) => void;
	tableHeaders: string[];
	tableDropdownHeaders: string[];
	yearStart: number;
	yearEnd: number;
	feedback_search: string;
}

export const CountyTaxTable = ({
	onTagSelected,
	onTagRemoved,
	tableHeaders,
	tableDropdownHeaders,
	yearStart,
	yearEnd,
	feedback_search,
}: CountyTaxTableProps) => {
	const [tableRows, setTableRows] = useState<TableCell[][]>([]);
	//slutår skal opdateres når Excel--fil opdateres
	const [selectedTags, setSelectedTags] = useState<string[]>([String(yearEnd)]);

	const convertCountyNameToId = (countyName: string) => {
		const result = countyTaxData.Kommuner.find((k) => k.B === countyName);
		return result.A;
	};
	const CountyNamesStartingWithAaLast = (countyArray: County[]) => {
		const aaWords = [];
		const otherWords = [];

		countyArray.forEach((county) => {
			if (county.name[0] === 'A' && county.name[1] === 'a') {
				aaWords.push(county);
			} else {
				otherWords.push(county);
			}
		});

		const sortedOtherWords = otherWords.sort();
		const reorderedArray = sortedOtherWords.concat(aaWords);

		return reorderedArray;
	};
	const NamesStartingWithAaLast = (countyArray: string[]) => {
		const aaWords = [];
		const otherWords = [];

		countyArray.forEach((county) => {
			if (county[0] === 'A' && county[1] === 'a') {
				aaWords.push(county);
			} else {
				otherWords.push(county);
			}
		});

		const sortedOtherWords = otherWords.sort();
		const reorderedArray = sortedOtherWords.concat(aaWords);

		return reorderedArray;
	};
	const allCountyNames: string[] = useMemo(() => {
		const countyNames: string[] = [];
		for (let i = 1; i < countyTaxData.Kommuner.length; i++) {
			countyNames.push(countyTaxData.Kommuner[i].B);
		}
		return countyNames;
	}, []);

	let countyList: County[] = countyTaxData.Kommuner.slice(1).map((item) => ({
		name: item.B,
		id: item.A.toString(),
		region: item.C.toString(),
	}));
	countyList.sort((a, b) => (a.name > b.name ? 1 : -1));
	countyList = CountyNamesStartingWithAaLast(countyList);

	const actualYearList: string[] = useMemo(() => {
		const yearString: string[] = [];
		for (let i = 0; i <= yearEnd - yearStart; i++) {
			yearString.push(String(yearStart + i));
		}
		return yearString.reverse();
	}, [yearEnd, yearStart]);

	useEffect(() => {
		let years: string[] = selectedTags.filter((t) => Number(t) && t !== undefined);
		let countyNames: string[] = selectedTags.filter((t) => !Number(t) && t !== undefined);
		countyNames.sort();
		countyNames = NamesStartingWithAaLast(countyNames);
		const showAllCounties = years.length === 1 && countyNames.length === 0;
		if (showAllCounties) {
			countyNames = NamesStartingWithAaLast([...allCountyNames.sort()]);
		}
		const showAllYears = years.length === 0 && (countyNames.length === 1 || countyNames.length === 2);
		if (showAllYears) {
			years = [...actualYearList];
		}
		//years.sort((a, b) => (a > b ? 1 : -1));
		const rowsArray: TableCell[][] = [];
		let county;
		let sum: number;
		for (const y in years) {
			for (const c in countyNames) {
				county = countyTaxData[years[y]].find((county) => county.A === convertCountyNameToId(countyNames[c]));
				sum = county && county.B + county.C + county.D + county.E;
				county !== undefined && console.log(county.B.toFixed(2).replace('.', ','));
				county !== undefined &&
					rowsArray.push([
						{ text: countyNames[c] },
						{ text: years[y], align: true },
						{ text: county.B.toFixed(2).replace('.', ','), align: true },
						{ text: county.C.toFixed(2).replace('.', ','), align: true },
						{ text: county.D.toFixed(2).replace('.', ','), align: true },
						{ text: county.E.toFixed(2).replace('.', ','), align: true },
						{ text: sum.toFixed(2).replace('.', ','), align: true },
						{ text: county.F.toFixed(2).replace('.', ','), align: true },
						{ text: county.G.toFixed(2).replace('.', ','), align: true },
					]);
			}
		}

		setTableRows(rowsArray);
	}, [allCountyNames, selectedTags, actualYearList]);

	const filterOnSelect = (inputValue: string) => {
		if (selectedTags.find((str) => str === inputValue)) {
			return;
		}
		const array = [...selectedTags];
		array.push(inputValue);
		setSelectedTags([...array]);
	};

	const filterOnRemove = (filterValue: string, index: number) => {
		const array = selectedTags.map((item) => {
			if (item !== filterValue) {
				return item;
			}
		});
		setSelectedTags([...array]);
		document.getElementById(`selectedFilter${index}`).remove();
	};

	return (
		<div className={classNames(styles.CountyTaxTable)}>
			{/* TODO - Use ListFilters instead*/}
			<div className={styles.CountyTaxTable__wrapper}>
				<div className={styles.CountyTaxTable__unit}>
					<TableDropdown
						title={tableDropdownHeaders[0]}
						id={'countiesId'}
						theme={'light'}
						options={countyList.map((county) => county.name)}
						onSelect={(e) => {
							filterOnSelect(e);
							onTagSelected(e);
						}}
						filterActive={true}
					/>
				</div>
				<div className={styles.CountyTaxTable__unit}>
					<TableDropdown
						title={tableDropdownHeaders[1]}
						id={'yearsId'}
						theme={'light'}
						options={actualYearList}
						onSelect={(e) => {
							filterOnSelect(e);
							onTagSelected(e);
						}}
					/>
				</div>
			</div>
			<div className={styles.CountyTaxTable___selectedTags}>
				{selectedTags.map((tag, i) => {
					return (
						<SelectedFilter
							key={i}
							id={`selectedFilter${i}`}
							text={tag}
							removeFilterText={tag}
							onElementRemoved={() => {
								filterOnRemove(tag, i);
								onTagRemoved(tag);
							}}
						/>
					);
				})}
			</div>
			<div>
				<Table simple={false} tableData={[{ tableHeaders, tableRows }]} />
				{tableRows.length === 0 && <div className={styles.CountyTaxTable__info}>{feedback_search}</div>}
			</div>
		</div>
	);
};
